import { render, staticRenderFns } from "./guest-detail.vue?vue&type=template&id=2b0280d6&"
import script from "./guest-detail.vue?vue&type=script&lang=ts&"
export * from "./guest-detail.vue?vue&type=script&lang=ts&"
import style0 from "./guest-detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports